module.exports = __webpack_public_path__ + "img/27.17ec366e.gif";